module.exports = __webpack_public_path__ + "img/8_47.50913cd2.png";